<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="iconButtonStyle">
    <img :src="icon" alt="" class="invert" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
export interface NumberItemProps {
  icon: string;
  isUmbraco?: boolean;
}

const props = withDefaults(defineProps<NumberItemProps>(), {
  isUmbraco: false,
});

const iconButtonStyle = computed(() => {
  return `w-20 h-20 lg:w-[100px] lg:h-[100px] rounded-full bg-orange flex items-center justify-center text-white mb-7 lg:mb-10`;
});
</script>
